export const fromFieldSettingsController = settings => {
    const isFieldVisible = id => settings.has(id) && settings.get(id).isVisible;
    const isFieldEditable = id => settings.has(id) && settings.get(id).isEditable;
    const isFieldRequired = id => settings.has(id) && settings.get(id).isRequired;

    return {
        isFieldVisible,
        isFieldEditable,
        isFieldRequired
    };
};
